var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C11.3806 0 11.728 0.216313 11.8965 0.557617L14.7529 6.3457L21.1445 7.28027C21.5211 7.33531 21.8338 7.59991 21.9512 7.96191C22.0684 8.32384 21.9698 8.72087 21.6973 8.98633L17.0742 13.4883L18.166 19.8506C18.2304 20.2258 18.0755 20.6054 17.7676 20.8291C17.4597 21.0527 17.0516 21.0822 16.7148 20.9053L11 17.8994L5.28514 20.9053C4.94833 21.0822 4.54028 21.0527 4.23241 20.8291C3.92443 20.6054 3.76962 20.2258 3.83397 19.8506L4.92479 13.4883L0.302721 8.98633C0.0301761 8.72087 -0.0684155 8.32384 0.0488148 7.96191C0.166192 7.59991 0.478895 7.33531 0.855455 7.28027L7.24608 6.3457L10.1035 0.557617L10.1748 0.435547C10.3594 0.165559 10.667 0 11 0ZM8.80663 7.70215C8.66111 7.99696 8.37998 8.20143 8.05467 8.24902L3.14745 8.96582L6.69725 12.4238C6.93303 12.6535 7.04084 12.9842 6.98534 13.3086L6.14745 18.1914L10.5342 15.8848C10.8255 15.7315 11.1744 15.7315 11.4658 15.8848L15.8515 18.1914L15.0146 13.3086C14.9591 12.9842 15.0669 12.6535 15.3027 12.4238L18.8515 8.96582L13.9453 8.24902C13.62 8.20143 13.3389 7.99696 13.1933 7.70215L11 3.25781L8.80663 7.70215Z",
    fill: "#11B55F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineStar);
export default __webpack_public_path__ + "static/media/outlineStar.792f4462debfdc178470f6d6b264f444.svg";
export { ForwardRef as ReactComponent };